const fetcher = require('od-modules/utils/fetcher');

const isMobile = () => Odigeo.SessionScope.flow === 'mobile';

const isInScope = () => isMobile();

const formatUrl = (url) => Odigeo.Settings.getProperty('ancillariesUrlFormatter')(url);

const getFareRules = () => fetcher.get(formatUrl('availables/fare-rules')).json();

const filterFareRules = (items = []) => items.find(({template = ''}) => template === 'fareRules');

const getProducts = ({products = []} = {}) => products;

const hasFareRules = (items = []) => getProducts(filterFareRules(items) || {}).length > 0;

module.exports = {
    isInScope,
    hasFareRules,
    getFareRules,
};
